import {Component, Input} from '@angular/core';
import {ReactiveFormsModule, FormGroup, FormsModule} from "@angular/forms";
import {ButtonModule} from 'primeng/button';
import {InputTextModule} from "primeng/inputtext";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {UserService} from "../../../shared/services/user.service";
import {NgForOf, NgIf} from "@angular/common";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {IframeDialogComponent} from "../../../shared/iframe-dialog/iframe-dialog.component";
import {environment} from "../../../../environments/environment";
import {UserProperties, UserPropertiesService} from "../../services/user-properties.service";
import {log} from "@angular-devkit/build-angular/src/builders/ssr-dev-server";
import {ProfilePictureCropperComponent} from "./profile-picture-cropper/profile-picture-cropper.component";
import {
    SignatureImageCropperComponent
} from "../visual-signature/signature-image-cropper/signature-image-cropper.component";
import {SipoService} from "../../services/SipoService";
import {ChartModule} from "primeng/chart";
import {SignerModel} from "../../model/signer-model";

@Component({
    selector: 'app-profil-data',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        TranslatePipe,
        NgIf,
        ProfilePictureCropperComponent,
        ChartModule,
        NgForOf,
    ],
    providers: [DialogService],
    templateUrl: './profil-data.component.html',
    styleUrl: './profil-data.component.scss'
})
export class ProfilDataComponent {
    ref!: DynamicDialogRef;
    pieChartData: any;
    pieChartOptions: any;
    barChartData: any;
    barChartOptions: any;
    totalDocumentAmount!: number;
    finishedDocumentAmount!: number;
    inProgressDocumentAmount!: number;
    purchases: {
        date: string;
        amount: string;
        type: 'Credit Purchase' | 'Subscription Plan Upgrade' | 'Subscription Renewal'
    }[] = [
        {date: '12.07.2025', amount: '18.50 €', type: 'Subscription Plan Upgrade'},
        {date: '15.07.2025', amount: '20 €', type: 'Credit Purchase'},
        {date: '25.07.2025', amount: '30 €', type: 'Credit Purchase'},
        {date: '02.08.2025', amount: '15 €', type: 'Credit Purchase'},
        {date: '08.08.2025', amount: '10 €', type: 'Credit Purchase'},
        {date: '12.08.2025', amount: '18.50 €', type: 'Subscription Renewal'},
        {date: '88.08.2025', amount: '12 €', type: 'Credit Purchase'},
    ]

    user!: {
        activted: boolean,
        email: string,
        firstname: string,
        lastname: string,
        id: string,
        role: string,
        secondfactor: boolean,
        sendinitialmail: boolean,
        timestamp: number
    }

    //profile pic variables
    selectedFile: File | null = null;
    profilePictureProperty!: UserProperties;
    imageChangeEvent: Event | null = null;

    constructor(private http: HttpClient,
                private dialogService: DialogService,
                private userService: UserService,
                private userPropertiesService: UserPropertiesService,
                private sipoService: SipoService,
                private translate: TranslateService) {
    }

    ngOnInit(): void {
        this.getUsurInfo();

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');

        this.sipoService.getSigningProcessList().subscribe((res: SignerModel[]) => {

            const temp = res.filter(x=>x.fileName != null);

            this.totalDocumentAmount = temp.filter((doc: any) => doc.signType).length;
            this.finishedDocumentAmount = temp.filter((doc: any) => doc.status === 'finished').length;
            this.inProgressDocumentAmount = temp.filter((doc: any) => doc.signType && doc.status === 'created').length;

            this.pieChartData = {
                labels: ['EES', 'EES+', 'FES', 'QES'],
                datasets: [
                    {
                        data: [
                            temp.filter((doc: any) => doc.signType === 'basic').length,
                            temp.filter((doc: any) => doc.signType === 'basiccert').length,
                            temp.filter((doc: any) => doc.signType === 'high').length,
                            temp.filter((doc: any) => doc.signType === 'max').length,
                        ],
                        backgroundColor: [documentStyle.getPropertyValue('--primary-400'), documentStyle.getPropertyValue('--secondary-500'), documentStyle.getPropertyValue('--green-700'), documentStyle.getPropertyValue('--orange-600')],
                        hoverBackgroundColor: [documentStyle.getPropertyValue('--primary-300'), documentStyle.getPropertyValue('--secondary-400'), documentStyle.getPropertyValue('--green-600'), documentStyle.getPropertyValue('--orange-500')]
                    }
                ]
            };

            this.barChartData = {
                labels: ['EES', 'EES+', 'FES', 'QES'],
                    datasets: [
                {
                    type: 'bar',
                    label: this.translate.instant('sipo.profile-data-component.finished-documents'),
                    backgroundColor: documentStyle.getPropertyValue('--secondary-500'),
                    data: [
                        res.filter((doc: any) => doc.signType === 'basic' && doc.status === 'finished').length,
                        res.filter((doc: any) => doc.signType === 'basiccert' && doc.status === 'finished').length,
                        res.filter((doc: any) => doc.signType === 'high' && doc.status === 'finished').length,
                        res.filter((doc: any) => doc.signType === 'max' && doc.status === 'finished').length,
                    ]
                },
                {
                    type: 'bar',
                    label: this.translate.instant('sipo.profile-data-component.in-progress-documents'),
                    backgroundColor: documentStyle.getPropertyValue('--primary-400'),
                    data: [
                        res.filter((doc: any) => doc.signType === 'basic' && doc.status != 'finished').length,
                        res.filter((doc: any) => doc.signType === 'basiccert' && doc.status != 'finished').length,
                        res.filter((doc: any) => doc.signType === 'high' && doc.status != 'finished').length,
                        res.filter((doc: any) => doc.signType === 'max' && doc.status != 'finished').length,
                    ]
                }
            ]
            };


        });

        this.pieChartOptions = {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        color: textColor
                    }
                }
            }
        };

        this.barChartOptions = {
            maintainAspectRatio: false,
            aspectRatio: 1,
            plugins: {
                tooltip: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        // color: textColorSecondary
                    },
                    grid: {
                        // color: surfaceBorder,
                        drawBorder: false
                    }
                },
                y: {
                    stacked: true,
                    ticks: {
                        // color: textColorSecondary
                    },
                    grid: {
                        // color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };
    }

    getDocuments() {

    }

    getUsurInfo() {
        this.userService.getLoggedInUser().subscribe({
            next: (data) => {
                this.user = data;
            },
            error: (error: HttpErrorResponse) => {
                console.error('Error occurred while fetching user data:', {
                    status: error.status,
                    statusText: error.statusText,
                    message: error.message,
                    url: error.url
                });
            },
        });

        this.userPropertiesService.getByKey('sipo.profile.picture').subscribe({
            next: (data) => {
                if (data) {
                    this.profilePictureProperty = data;
                }
            },
            error: (error) => {
                if (error.status === 404) {
                    const pp = {
                        userPropertyKey: 'sipo.profile.picture',
                        userPropertyValue: '',
                        type: 'string',
                        propertyGroup: 'profile',
                    }
                    this.userPropertiesService.create(pp).subscribe({
                        next: (data) => {
                            console.log(data);
                        },
                        error: (error) => {
                            console.error(error);
                        }
                    })
                }
            }
        })
    }

    saveChanges() {
        const url = `/api/users/protected/user/${this.user.id}`;
        this.http.put(url, this.user).subscribe(data => {
            this.userPropertiesService.update(this.profilePictureProperty).subscribe(res => {
                this.getUsurInfo()
            });
        });
    }

    open2Fa() {

        this.ref = this.dialogService.open(IframeDialogComponent, {
            header: "Change 2Fa login",
            width: '50%',
            height: '70%',
            showHeader: true,
            data: {
                url: environment.twoFactorUrl
            },

        });
        this.ref.onClose.subscribe(value => {
            if (value) {
            }
        });
    }

    // image cropping component events and variables
    isImageCropperDisplaying: boolean = false;

    receiveProfilePicture(blob: Blob | null) {
        const reader = new FileReader();
        reader.onloadend = () => {
            this.profilePictureProperty.userPropertyValue = reader.result as string;
        };

        if (blob) {
            reader.readAsDataURL(blob);
        }

        this.isImageCropperDisplaying = false;
    }

    // the Event type variable "imageSelectionEvent" is catched with input in the signature-image-cropper-component and used in it. The method "onFileSelected" is used to select file, declare it to imageSelectionEvent and then display signature-image-cropper-component
    imageSelectionEvent: Event | null = null;

    onFileSelected(event: Event) {
        this.imageSelectionEvent = event;
        this.isImageCropperDisplaying = true;
    }
}
